'use client'
import { ProductListItemProps } from 'storefront-modules/products'
import ProductListItemComponent from 'storefront-modules/products/components/ProductListItem'
import CustomProductListItemBuy from '#/src/custom/products/CustomProductListItemBuy'

export const CustomProductListItem = ({
  imageAspectRatio = 0,
  customComponents,
  ...props
}: ProductListItemProps) => (
  <ProductListItemComponent
    imageAspectRatio={imageAspectRatio}
    py={4}
    customComponents={{ ProductListItemBuy: CustomProductListItemBuy, ...customComponents }}
    {...props}
  />
)
